import styled from 'styled-components';
import PropTypes from 'prop-types';
import { COLOR_WHITE, COLOR_NAVY, COLOR_ORANGE, VALIDATION_RED, PLACEHOLDER_GREY } from '../constants';

const propTypes = {
  small: PropTypes.bool,
  big: PropTypes.bool,
  semiBold: PropTypes.bool,
  bold: PropTypes.bool,
  secondary: PropTypes.bool,
  primary: PropTypes.bool,
  white: PropTypes.bool,
  error: PropTypes.bool,
};

const Typography = styled.p`
  line-height: 20px;
  ${p => p.small && 'font-size: 14px'};
  ${p => p.big && 'font-size: 20px'};
  ${p => p.semiBold && 'font-weight: 600'};
  ${p => p.bold && 'font-weight: 700'};
  ${p => p.secondary && `color: ${COLOR_ORANGE}`};
  ${p => p.primary && `color: ${COLOR_NAVY}`};
  ${p => p.white && `color: ${COLOR_WHITE}`};
  ${p => p.error && `color: ${VALIDATION_RED}`};
  ${p => p.grey && `color: ${PLACEHOLDER_GREY}`};
`;

Typography.propTypes = propTypes;
Typography.displayName = 'Typography';
export default Typography;
